import React from 'react';
import { aspectRatioOptions } from '../data/vehicleData.js';
import SafeIcon from '../common/SafeIcon.jsx';
import * as FiIcons from 'react-icons/fi';

const { FiMonitor, FiSquare, FiSmartphone, FiCreditCard, FiImage } = FiIcons;

const AspectRatioSelector = ({ selectedAspectRatio, onAspectRatioChange }) => {
  const getIcon = (id) => {
    switch (id) {
      case 'landscape': return FiMonitor;
      case 'square': return FiSquare;
      case 'portrait': return FiSmartphone;
      case 'banner': return FiCreditCard;
      case 'print': return FiImage;
      default: return FiImage;
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800">Image Size & Format</h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {aspectRatioOptions.map((option) => (
          <button
            key={option.id}
            onClick={() => onAspectRatioChange(option.id)}
            className={`p-4 rounded-lg border-2 transition-all duration-200 text-left ${
              selectedAspectRatio === option.id
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
            }`}
          >
            <div className="flex items-start space-x-3">
              <SafeIcon 
                icon={getIcon(option.id)} 
                className={`w-5 h-5 mt-0.5 ${
                  selectedAspectRatio === option.id ? 'text-blue-600' : 'text-gray-400'
                }`} 
              />
              <div className="flex-1 min-w-0">
                <div className="font-medium">{option.name}</div>
                <div className={`text-sm mt-1 ${
                  selectedAspectRatio === option.id ? 'text-blue-600' : 'text-gray-500'
                }`}>
                  {option.description}
                </div>
                <div className={`text-xs mt-1 font-mono ${
                  selectedAspectRatio === option.id ? 'text-blue-500' : 'text-gray-400'
                }`}>
                  {option.dimensions}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AspectRatioSelector;